"use strict";

var _slicedToArray = require("/home/runner/work/moderneyegallery/moderneyegallery/node_modules/@babel/runtime/helpers/slicedToArray.js");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var hastscript_1 = require("hastscript");

var react_1 = __importStar(require("react"));

var rehype_raw_1 = __importDefault(require("rehype-raw"));

var rehype_stringify_1 = __importDefault(require("rehype-stringify"));

var remark_directive_1 = __importDefault(require("remark-directive"));

var remark_gfm_1 = __importDefault(require("remark-gfm"));

var remark_parse_1 = __importDefault(require("remark-parse"));

var remark_rehype_1 = __importDefault(require("remark-rehype"));

var remark_unwrap_images_1 = __importDefault(require("remark-unwrap-images"));

var unified_1 = require("unified");

var unist_util_visit_1 = require("unist-util-visit");

var myRemarkPlugin = function myRemarkPlugin() {
  return function (tree) {
    (0, unist_util_visit_1.visit)(tree, function (node) {
      if ('textDirective' === node.type || 'leafDirective' === node.type || 'containerDirective' === node.type) {
        var name = node.name,
            attributes = node.attributes;
        var data = node.data || (node.data = {});
        var hast = (0, hastscript_1.h)(name, attributes);
        data.hName = hast.tagName;
        data.hProperties = hast.properties;
      }
    });
  };
};

var Markdown = function Markdown(_ref) {
  var className = _ref.className,
      _ref$refs = _ref.refs,
      refs = _ref$refs === void 0 ? {} : _ref$refs,
      text = _ref.text;

  var _ref2 = (0, react_1.useState)(),
      _ref3 = _slicedToArray(_ref2, 2),
      file = _ref3[0],
      setFile = _ref3[1];

  (0, react_1.useEffect)(function () {
    if (text) {
      var newText = "".concat(text, "\n\n");

      if (refs) {
        Object.keys(refs).forEach(function (key) {
          if (refs[key].length > 0) {
            refs[key].forEach(function (ref, index) {
              newText += "\n[".concat(key, ".").concat(index + 1, "]: ").concat(ref);
            });
          }
        });
      }

      (0, unified_1.unified)().use(remark_parse_1.default).use(remark_unwrap_images_1.default).use(remark_gfm_1.default).use(remark_directive_1.default).use(myRemarkPlugin).use(remark_rehype_1.default, {
        allowDangerousHtml: true
      }).use(rehype_raw_1.default).use(rehype_stringify_1.default).process(newText).then(setFile).catch(console.error);
    }
  }, [refs, text]);

  if (!file) {
    return null;
  }

  return react_1.default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: String(file)
    },
    className: className
  });
};

exports.default = Markdown;